var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExternalLinkArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 14,
    viewBox: "0 0 13 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "arrow-up-right-from-square-regular 2",
    clipPath: "url(#clip0_39349_7615)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M6.53253 1.11719C6.53253 1.40293 6.76245 1.63281 7.04825 1.63281H9.24224L4.44813 6.42383C4.24614 6.62578 4.24614 6.95234 4.44813 7.15215C4.65013 7.35195 4.97675 7.3541 5.1766 7.15215L9.96855 2.36113V4.55469C9.96855 4.84043 10.1985 5.07031 10.4843 5.07031C10.7701 5.07031 11 4.84043 11 4.55469V1.11719C11 0.831445 10.7701 0.601562 10.4843 0.601562H7.04825C6.76245 0.601562 6.53253 0.831445 6.53253 1.11719ZM1.54718 1.28906C0.691932 1.28906 0 1.98086 0 2.83594V10.0547C0 10.9098 0.691932 11.6016 1.54718 11.6016H8.76734C9.62258 11.6016 10.3145 10.9098 10.3145 10.0547V7.30469C10.3145 7.01895 10.0846 6.78906 9.79879 6.78906C9.51299 6.78906 9.28306 7.01895 9.28306 7.30469V10.0547C9.28306 10.3404 9.05313 10.5703 8.76734 10.5703H1.54718C1.26138 10.5703 1.03145 10.3404 1.03145 10.0547V2.83594C1.03145 2.5502 1.26138 2.32031 1.54718 2.32031H4.29771C4.58351 2.32031 4.81344 2.09043 4.81344 1.80469C4.81344 1.51895 4.58351 1.28906 4.29771 1.28906H1.54718Z",
    fill: "#5E06B9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_39349_7615"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13,
    height: 13,
    fill: "white",
    transform: "translate(0 0.101562)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExternalLinkArrow);
export default __webpack_public_path__ + "static/media/external-link-arrow.203a0271b73309856fa1701ca5d6fa17.svg";
export { ForwardRef as ReactComponent };